import { T } from "services/lang/LanguageService";

export interface LastValueIndicatorProps {
  valueDataset: string;
  title: string;
  subtitle: string;
  displayLastValueDiff: boolean;
  diffType: string;
  updateFrequency?: number;
  diffValueDecimalPlaces?: number;
  useDiffIndicatorColors?: boolean;
  highlightValue?: boolean;
}

export enum DiffType {
  ABSOLUTE = "absolute",
  PERCENTAGE = "percentage",
}

export const diffTypeOptions = [
  { label: T("word.absolute"), value: DiffType.ABSOLUTE },
  { label: T("word.percentage"), value: DiffType.PERCENTAGE },
];
